/**
 * Created by Simone.Sacchi on 18/01/2017.
 */

"use strict";

var _default = window.sessionStorage;

var ClientStorageSingleton = (function () {

    // ==========================================
    // PRIVATE
    // ==========================================
    var _storage = {};

    // ==========================================
    // PUBLIC
    // ==========================================
    return {

        setItem : function (key, value) {
            _storage[key] = value;
        },
        getItem : function (key) {
            if (_storage.hasOwnProperty(key)) {
                return _storage[key];
            }
        },
        removeItem : function (key) {
            if (_storage.hasOwnProperty(key)) {
                delete _storage[key];
            }
        },
        clear : function () {
            _storage = {};
        }

    };

}());

module.exports = _default ? _default : ClientStorageSingleton;